export default "__VITE_ASSET__5bbdd436__"